import * as React from 'react';
import { type, space, typeColors } from '@workday/canvas-kit-react/tokens';
import { accessibleHide, styled, createComponent, } from '@workday/canvas-kit-react/common';
import { Flex } from '@workday/canvas-kit-react/layout';
import { useLiveRegion } from './common/useLiveRegion';
import { PaginationContext } from './usePaginationModel';
const StyledAdditionalDetails = styled(Flex)(({ shouldHideDetails }) => {
    if (shouldHideDetails) {
        return {
            ...accessibleHide,
            marginTop: space.zero,
        };
    }
    else {
        return {
            marginTop: space.xs,
        };
    }
});
export const AdditionalDetails = createComponent('div')({
    displayName: 'Pagination.AdditionalDetails',
    Component({ children, shouldAnnounceToScreenReader, ...elemProps }, ref, Element) {
        const model = React.useContext(PaginationContext);
        const liveRegionProps = useLiveRegion({ shouldAnnounceToScreenReader });
        return (React.createElement(StyledAdditionalDetails, Object.assign({ ref: ref, as: Element }, type.levels.subtext.medium, { color: typeColors.hint }, liveRegionProps, elemProps), typeof children === 'function' ? children(model) : children));
    },
});
